import { normalizeAllowedRoutes } from '@/core/auth/permissions';
/**
 * Map Platform /v1/me into the UI session shape expected by ProtectedRoute / Layout.
 * Platform roles (tenant_admin/viewer/…) → legacy SUPERADMIN|ADMIN|VIEWER.
 */
export function mapPlatformMeToSessionUser(me) {
  const roles = Array.isArray(me?.roles) ? me.roles : [];
  const perms = Array.isArray(me?.permissions) ? me.permissions : [];
  const platformAdmin = Boolean(me?.platform_admin) || roles.includes('platform_admin');
  let role = 'VIEWER';
  if (platformAdmin) role = 'SUPERADMIN';
  else if (roles.includes('tenant_admin')) role = 'ADMIN';
  else if (roles.includes('operator')) role = 'ADMIN';

  const display = me?.user?.display_name || '';
  const parts = display.trim().split(/\s+/);
  const first = parts[0] || me?.user?.email || '';
  const last = parts.slice(1).join(' ');

  const siteIds = (me?.site_access || []).map((s) => s.site_id).filter(Boolean);
  const uiRoutes = me?.user?.ui_allowed_routes;
  const allowed =
    Array.isArray(uiRoutes) && uiRoutes.length > 0
      ? normalizeAllowedRoutes(uiRoutes)
      : null; // null = all routes allowed by role gates

  return {
    id: me?.user?.id,
    username: me?.user?.identity_provider_subject || me?.user?.email,
    email: me?.user?.email,
    first_name: first,
    last_name: last,
    role,
    status: (me?.user?.status || 'active').toUpperCase() === 'ACTIVE' ? 'ACTIVE' : 'INACTIVE',
    company_ids: siteIds,
    allowed_routes: allowed,
    // platform extras
    platform_roles: roles,
    platform_permissions: perms,
    tenant_id: me?.tenant_id,
    tenant_slug: me?.tenant_slug,
    site_access: me?.site_access || [],
    platform_admin: platformAdmin,
  };
}

export function legacyRoleToPlatformRole(legacy) {
  switch (legacy) {
    case 'SUPERADMIN':
      return 'platform_admin';
    case 'ADMIN':
      return 'tenant_admin';
    default:
      return 'viewer';
  }
}

export function platformUserToLegacyListItem(u) {
  const roles = u.roles || [];
  let role = 'VIEWER';
  if (roles.includes('platform_admin')) role = 'SUPERADMIN';
  else if (roles.includes('tenant_admin') || roles.includes('operator')) role = 'ADMIN';
  const display = u.display_name || '';
  const parts = display.trim().split(/\s+/);
  return {
    id: u.id,
    username: u.identity_provider_subject,
    email: u.email,
    first_name: parts[0] || display,
    last_name: parts.slice(1).join(' '),
    role,
    status: (u.status || 'active').toUpperCase() === 'ACTIVE' ? 'ACTIVE' : 'INACTIVE',
    company_ids: (u.site_access || []).map((s) => s.site_id),
    allowed_routes: u.ui_allowed_routes || [],
    platform: u,
  };
}
